export function isPresentationsAiEnabled(serverFlag?: boolean): boolean {
  if (typeof serverFlag === 'boolean') return serverFlag;
  return process.env.REACT_APP_PRESENTATIONS_AI === 'true';
}

export function isPresentationsAiGenerateEnabled(serverFlag?: boolean): boolean {
  if (typeof serverFlag === 'boolean') return serverFlag;
  return process.env.REACT_APP_PRESENTATIONS_AI_GENERATE === 'true';
}
